var _path, _mask, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSvg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 5.30397L23.656 10.6666H19.6187C19.0934 10.6666 18.6667 10.1586 18.6667 9.5333V5.30397ZM26.3214 9.77063L20.3947 3.10396C20.1427 2.82529 19.784 2.66663 19.408 2.66663H8.74137C6.86137 2.66663 5.33337 4.16263 5.33337 5.99996V26C5.33337 27.8373 6.86137 29.3333 8.74137 29.3333H23.2587C25.1387 29.3333 26.6667 27.8373 26.6667 26V10.6666C26.6667 10.3346 26.544 10.016 26.3214 9.77063V9.77063Z",
    fill: "#F7B84E"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 5.30397L23.656 10.6666H19.6187C19.0934 10.6666 18.6667 10.1586 18.6667 9.5333V5.30397ZM26.3214 9.77063L20.3947 3.10396C20.1427 2.82529 19.784 2.66663 19.408 2.66663H8.74137C6.86137 2.66663 5.33337 4.16263 5.33337 5.99996V26C5.33337 27.8373 6.86137 29.3333 8.74137 29.3333H23.2587C25.1387 29.3333 26.6667 27.8373 26.6667 26V10.6666C26.6667 10.3346 26.544 10.016 26.3214 9.77063V9.77063Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08172 18.2835C9.24424 16.9135 11.3128 16.6671 12.2879 17.4161C12.7684 17.8038 12.2597 18.4186 11.8357 18.1077C11.3128 17.7756 10.1266 17.6201 9.97822 18.3541C9.78744 19.5129 12.8594 18.8496 12.8108 20.7274C12.7613 22.5213 10.1619 22.5637 9.18683 21.7582C8.95365 21.5683 8.96071 21.2582 9.0879 21.0666C9.27162 20.8837 9.47653 20.8201 9.71678 21.0171C10.2953 21.4128 11.7862 21.7096 11.8913 20.7053C11.8004 19.6613 8.86267 20.2902 9.08172 18.2835Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2812 21.7944L13.4167 17.8887C13.1411 17.3305 13.9749 16.8721 14.2849 17.4577L14.9138 18.877L15.7255 20.7416L16.5231 18.877L17.152 17.4577C17.4346 16.9215 18.2534 17.2598 18.014 17.8463L16.2131 21.7944C16.0505 22.2396 15.5497 22.3447 15.2812 21.7944Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8242 21.5683C22.3225 21.9843 21.7078 22.1618 21.0868 22.1618C19.603 22.1618 18.551 21.3139 18.551 19.6331C18.551 18.2066 19.6604 17.0981 21.1496 17.0981C21.7078 17.0981 22.3216 17.2889 22.7597 17.72C23.1899 18.143 22.5689 18.7719 22.1459 18.3983C21.8844 18.143 21.517 17.9531 21.1496 17.9531C20.2954 17.9531 19.4696 18.6377 19.4696 19.6331C19.4696 20.6788 20.1612 21.3139 21.0868 21.3139C21.517 21.3139 21.8844 21.1867 22.1459 20.9959V20.1286H21.0868C20.458 20.1286 20.5216 19.2656 21.0868 19.2656H22.4992C22.7606 19.2656 23 19.4644 23 19.6834V21.1876C23.0008 21.3139 22.9443 21.4331 22.8242 21.5683Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSvg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/svg.c88a3b35.svg";
export { ForwardRef as ReactComponent };